import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import { StoreState } from '../../reducers';
import ApiUtils from '../../utils/api';
import RoutesUtils from '../../utils/routes';
import { updateDriveItem } from '../DriveItemList/actions';
import { createNotification } from '../NotificationBar/actions';

export const finishProposalSharing = (resourceId: number) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	try {
		const resource = await ApiUtils.getMeta(resourceId);
		dispatch(updateDriveItem(resource));
		RoutesUtils.redirectToParentDir(resource.parent);
	} catch (error) {
		dispatch(createNotification('error.share_proposal_error'));
	}
};

export const shareProposalByEmail = (clientId: number, resourceId: number, label: string) => async (dispatch: Dispatch<StoreState>): Promise<void> => {
	try {
		const {
			pin,
			resourceUrl,
		} = await ApiUtils.shareProposal(clientId, resourceId, label);

		dispatch(finishProposalSharing(resourceId));

		const mailText = encodeURIComponent(`${label}\n${resourceUrl}\n${pin ? `${I18n.t('messages.pin_code')}: ${pin}` : ''}`);
		window.open(`mailto:?body=${mailText}`, '_self');
	} catch (error) {
		dispatch(createNotification('error.share_proposal_error'));
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ShareProposal/actions.ts